(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CommunicationStatus', CommunicationStatus);

    CommunicationStatus.$inject = ['$resource'];

    function CommunicationStatus ($resource) {
        var resourceUrl =  'api/communication-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
